import { SET_SESSION_INFORMATION } from "../types/contextTypes";

export default (state, action) => {
  switch (action.type) {
    case SET_SESSION_INFORMATION:
      return {
        ...state,
        sessionInformation: action.payload
      };
    default:
      return state;
  }
};